import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, Card, Checkbox, Pagination } from "antd";
import { useHistory, useLocation } from "react-router-dom";
import {
  getSystemMessages,
  selectSystemMessages,
  selectSystemMessagePagination,
} from "../../../routes/SystemMessage/systemMessage.ducks";
import { calculateTotalPagingCount, scrollToTop, getCroatianPluralForm } from "../../../services";
import { PageRoute } from "../../../models";
import { TAB_PARAM, TAB_SYSTEM } from "../constants/constants";
import SystemMessageItem from "./SystemMessageItem";
import { Separator } from "../ChatsList/Separator";
import { useDeleteSystemMessages } from "../hooks/useDeleteSystemMessages";
import styles from "../chatPage.scss";

const ITEMS_PER_PAGE = 20;

const SystemMessagesList = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const messages = useSelector(selectSystemMessages);
  const pagination = useSelector(selectSystemMessagePagination);

  const [isLoading, setIsLoading] = useState(true);

  const {
    isAllSelected,
    handleSelectAll,
    isDeleting,
    setSelectedMessages,
    handleBatchDelete,
    selectedMessages,
  } = useDeleteSystemMessages(messages);

  useEffect(() => {
    setIsLoading(true);
    dispatch(getSystemMessages({ page: 1 }, () => {
      setIsLoading(false);
      if (location.state && location.state.scrollPosition) {
        setTimeout(() => window.scrollTo(0, location.state.scrollPosition), 0);
      }
    }));
  }, []);

  useEffect(() => {
    setSelectedMessages([]);
  }, [messages]);

  const handlePageChange = (page) => {
    scrollToTop();
    setIsLoading(true);
    dispatch(getSystemMessages({ page }, () => {
      setIsLoading(false);
    }));
  };

  const handleMessageClick = (messageId) => {
    history.replace({
      pathname: history.location.pathname,
      search: history.location.search,
      state: { scrollPosition: window.scrollY },
    });
    history.push({
      pathname: PageRoute.chats,
      search: `?${TAB_PARAM}=${TAB_SYSTEM}&messageId=${messageId}`,
    });
  };

  const handleMessageSelect = (messageId, checked) => {
    if (checked) {
      setSelectedMessages((prev) => [...prev, messageId]);
    } else {
      setSelectedMessages((prev) => prev.filter((id) => id !== messageId));
    }
  };

  return (
    <React.Fragment>
      <Card className={styles.chatsListCard} bordered={false}>
        <div className={styles.chatsListFilterWrapper}>
          <div>
            <Checkbox
              checked={isAllSelected}
              onChange={(e) => handleSelectAll(e.target.checked)}
              className={styles.selectAllCheckbox}
            >
              {isAllSelected ? "Odznači sve" : "Označi sve"}
            </Checkbox>
            {selectedMessages.length > 0 && (
              <span className={styles.selectedCount}>
                {selectedMessages.length} {getCroatianPluralForm(selectedMessages.length, "poruka", "poruke", "poruka")}
              </span>
            )}
            {selectedMessages.length > 0 && (
              <Button
                loading={isDeleting}
                onClick={handleBatchDelete}
                className={styles.deleteButton}
              >
                Obriši
              </Button>
            )}
          </div>
        </div>
        <Separator />
        {isLoading && (
          <React.Fragment>
            {Array.from({ length: 5 }).map((_, i) => (
              <React.Fragment key={i}>
                <div className={styles.skeletonItem}>
                  <div className={`${styles.skeletonCheckbox} ${styles.skeletonLoader}`} />
                  <div className={styles.skeletonContent}>
                    <div className={`${styles.skeletonSender} ${styles.skeletonLoader}`} />
                    <div className={`${styles.skeletonTitle} ${styles.skeletonLoader}`} />
                    <div className={`${styles.skeletonDate} ${styles.skeletonLoader}`} />
                  </div>
                </div>
                {i < 4 && <div className={styles.skeletonSeparator} />}
              </React.Fragment>
            ))}
          </React.Fragment>
        )}
        {!isLoading && (
          <React.Fragment>
            {messages.length === 0 && (
              <p className={styles.noChats}>Nemate sistemskih poruka</p>
            )}
            {messages.length > 0 &&
              messages.map((msg, index) => (
                <SystemMessageItem
                  key={msg.id}
                  message={msg}
                  onClick={handleMessageClick}
                  isLastItem={index === messages.length - 1}
                  isSelected={selectedMessages.includes(msg.id)}
                  onSelect={(checked) => handleMessageSelect(msg.id, checked)}
                />
              ))}
          </React.Fragment>
        )}
      </Card>
      {pagination && pagination.count > ITEMS_PER_PAGE && (
        <div className={styles.paginationWrapper}>
          <Pagination
            current={pagination.currentPage}
            total={calculateTotalPagingCount(pagination.count, pagination.currentPage)}
            onChange={handlePageChange}
            pageSize={ITEMS_PER_PAGE}
          />
        </div>
      )}
    </React.Fragment>
  );
};

export default SystemMessagesList;



// WEBPACK FOOTER //
// ./src/containers/ChatsPage/SystemMessages/SystemMessagesList.tsx